import { createWebStorage } from 'utils/storage';

import { AuthenticatedUser } from './types';

export type AuthStorageData = {
  user: AuthenticatedUser;
  currentSessionAttempt: { email: string; sessionId: string };
};

export const authStorage = createWebStorage<AuthStorageData>().init({
  user: '__adasmdalsd__',
  currentSessionAttempt: '__fsadfsd***',
});
